var e=function(){return Math.round((new Date).getTime()/1e3)};export{e as getCurrentTimestamp};
